export default __webpack_public_path__ + "media/src/assets/images/Icon_dashboard-3b295255d80712b1bd18f7e907894670.png";